import './Bookings.css'
import React, { useState, useEffect } from 'react';
import dayjs from "dayjs"; 

const Bookings = ({url, date}) => {
   const [bookings, setBookings] = useState([]);

   const fetchBookings = () => {
	fetch(`${url}?date=${date.format('YYYY-MM-DD')}`)
         .then((response) => response.json())
         .then((data) => {
            console.log(data);
            setBookings(data);
         })
         .catch((err) => {
            console.log(err.message);
         })
   };

   useEffect(() => {
    fetchBookings(); // Fetch initially

    const interval = setInterval(fetchBookings, 5000); // Refresh every 5 seconds

    return () => clearInterval(interval);
   }, [date, url]);

	return (
		<div className="bookings-container">
		  <div className="date-subtitle">
			Programările dumneavoastră 
			<div>în data de: <span className="date-field">{date.format('DD.MM.YYYY')}</span></div>
		  </div>
		  <div className="bookings-list">
                          {bookings.length == 0 && <div>Nu aveți programări.</div>}
			  {bookings.length > 0 && bookings.map((booking) => {
				 let bookDate = new Date(booking.date.replaceAll("Z",""));
				 let hours = bookDate.getHours().toString().padStart(2,'0');
				 let minutes = bookDate.getMinutes().toString().padStart(2,'0');
				 let bookTime = `${hours}:${minutes}`;
				 return (
					<div className="booking-card" key={booking.id}>
						<div className="time-cell">{bookTime}</div>
						<div className="name-cell">{booking.name}</div>
						<div className="reason-cell">{booking.reason}</div>
					</div>
				 );
			  })}
		  </div>
	   </div>
	);
};

export default Bookings;
